import { Container, Loader, LoaderResource } from 'pixi.js';
/**
 *
 */
export class LoaderDisplay extends Container {
  public autoProgress: boolean = true;
  /**
   * Call resolve when the animation is done.
   */
  transitionIn(resolve: Function) {
    resolve();
  }

  /**
   * Call resolve when the animation is done.
   */
  transitionOut(resolve: Function) {
    resolve();
  }

  /**
   * Fires on load progress.
   */
  onProgress(loader: Loader, resource: LoaderResource) {}

  /**
   * Fires on load complete.
   */
  onComplete(loader: Loader, resource: LoaderResource) {}
}
